/**
 * Validates if passed string is not valid. In case if it's of different type
 * still it returns true
 *
 * @param string String to be validated
 */
module.exports = (string) => {
  return (typeof string !== 'string' || !string.trim());
};
